import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  RESET_FILTERS,
  FETCH_NOTIFICATIONS_SUCCESS,
  ADD_NOTIFICATION_SUCCESS,
  EDIT_NOTIFICATION_SUCCESS,
  SET_SELECTED,
  DELETE_NOTIFICATION_SUCCESS,
  SET_ARCHIVES,
  SET_NOTIFICATIONS_LOADING,
  UPDATE_NOTIFICATION_LIST_BY_ARCHIVED
} from "./notificationsSagas";

export const initialState = {
  currentUser: {},
  isLoading: true,
  isNotificationsLoading: false,
  filtersDirty: false,
  notifications: [],
  primaryButtonDisabled: true,
  archives: false,
  selected: {
    notificationId: null,
    all_organizations: false,
    published: false,
    archived: false,
    organization_ids: [],
    message: "",
    title: ""
  }
};

function sortById(a, b) {
  return a.id > b.id ? 1 : -1;
}

export default handleActions(
  {
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      areChartsLoading: action.payload
    }),
    [RESET_FILTERS]: (state) => ({
      ...state,
      filtersDirty: false,
      primaryButtonDisabled: true,
      selected: {
        ...initialState.selected
      }
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_NOTIFICATIONS_LOADING]: (state, action) => ({
      ...state,
      isNotificationsLoading: action.payload
    }),
    [UPDATE_NOTIFICATION_LIST_BY_ARCHIVED]: (state, action) => {
      const { id, archived } = action.payload;

      if (archived !== state.archives) {
        return {
          ...state,
          notifications: state.notifications.filter((notification) => id !== notification.id)
        };
      }
      return {
        ...state
      };
    },
    [SET_SELECTED]: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        ...action.payload
      }
    }),
    [SET_ARCHIVES]: (state, action) => ({
      ...state,
      archives: action.payload
    }),

    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    }),
    [FETCH_NOTIFICATIONS_SUCCESS]: (state, action) => ({
      ...state,
      notifications: action.payload.sort(sortById)
    }),
    [ADD_NOTIFICATION_SUCCESS]: (state, action) => {
      if (action.payload.archived === state.archives) {
        return {
          ...state,
          notifications: [...state.notifications, action.payload]
        };
      }
      return {
        ...state
      };
    },
    [EDIT_NOTIFICATION_SUCCESS]: (state, action) => {
      let notifications = state.notifications.map((notification) => {
        if (notification.id === action.payload.id) {
          return action.payload.notification;
        }
        return notification;
      });

      return {
        ...state,
        notifications
      };
    },
    [DELETE_NOTIFICATION_SUCCESS]: (state, action) => {
      let notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );

      return {
        ...state,
        notifications
      };
    }
  },

  initialState
);
